import { useEffect, useState } from 'react';

// Reveals `text` one character at a time on mount, once. `speed` is the delay
// between characters in ms. Honors prefers-reduced-motion: users who opt out of
// motion get the full string immediately, with no interval running.
export default function useTypewriter(text, speed = 55) {
  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const [count, setCount] = useState(prefersReducedMotion ? text.length : 0);

  useEffect(() => {
    if (prefersReducedMotion) {
      setCount(text.length);
      return undefined;
    }
    setCount(0);
    let typedCount = 0;
    const id = setInterval(() => {
      if (typedCount >= text.length) {
        clearInterval(id);
        return;
      }
      typedCount += 1;
      setCount(typedCount);
    }, speed);
    return () => clearInterval(id);
  }, [text, speed, prefersReducedMotion]);

  return {
    typed: text.slice(0, count),
    done: count >= text.length,
  };
}
